// extracted by mini-css-extract-plugin
export default {"logo":"logo_logo__6BtIs","sidebar":"logo_sidebar__-VD0e","onboarding":"logo_onboarding__oqx6q"};